export default __webpack_public_path__ + "static/media/Single Process - Equal.119cfe5e.png";